import { useCallback } from 'react'
import { useMutation } from '@apollo/client'
import { cmsRoutes, useLink } from 'routes/cmsRoutes'
import { CREATE_PROMO_CODE } from 'queries/promoCode'
import { CreatePromocodeInput } from '__generatedTypes__/globalTypes'
import { createPromoCode, createPromoCodeVariables } from '__generatedTypes__/createPromoCode'
import { findAllPlatforms_findAllPlatforms_items as Platform } from '__generatedTypes__/findAllPlatforms'
import withPlatformCheck from 'HOCs/withPlatformCheck'
import { toast } from 'utils/toast'
import { Form } from '../Form'

type Props = {
  platform: Platform
}

export const Create = withPlatformCheck(({ platform }: Props) => {
  const { navigate } = useLink()
  const [create] = useMutation<createPromoCode, createPromoCodeVariables>(CREATE_PROMO_CODE)

  const handleSubmit = useCallback(
    async (promoCode: CreatePromocodeInput) => {
      try {
        const { data, errors } = await create({
          variables: {
            params: {
              ...promoCode,
              platform: {
                id: platform.id,
              },
            },
          },
        })

        if (errors) {
          throw new Error(errors[0].message ?? 'Something went wrong!')
        }

        if (data?.createPromocode.id) {
          navigate(cmsRoutes.PROMO_CODES_LIST)
          toast.success('Discount code created successfully')
        } else {
          toast.error('Failed to create discount code')
        }
      } catch (error) {
        if ((error as Error)?.message?.includes('already exists')) {
          toast.error(`Discount code "${promoCode.code}" already exists`)
          return
        }
        toast.error('Failed to create discount code')
      }
    },
    [create, navigate]
  )

  return <Form platform={platform} onSubmit={handleSubmit} />
})
